import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { formatPrice } from 'utils/utils';

const FormulaCalculator = () => {
  const [expression, setExpression] = useState("");
  const [result, setResult] = useState(0);

  const handleCalculate = (val) => {
    setExpression(val);
    try {
      // safe eval for basic math
      // remove anything except digits, +, -, *, /, ., (, )
      const sanitized = val.replace(/[^0-9+\-*/.()]/g, '');
      if (sanitized) {
        // eslint-disable-next-line no-eval
        const res = eval(sanitized);
        setResult(res);
      } else {
        setResult(0);
      }
    } catch (e) {
      setResult("Invalid Formula");
    }
  }

  return (
    <div className="mb-4">
      <h6 className="mb-2 text-muted">Kalkulator Net Agent (Excel Formula)</h6>
      <InputGroup size="sm">
        <InputGroup.Text>=</InputGroup.Text>
        <Form.Control 
          placeholder="e.g. 500000 + 350000 * 2" 
          value={expression}
          onChange={(e) => handleCalculate(e.target.value)}
        />
        <InputGroup.Text className="bg-success text-white">
          {typeof result === 'number' ? formatPrice(result) : result}
        </InputGroup.Text>
      </InputGroup>
    </div>
  )
}

export default FormulaCalculator;
